// V2デバイスのIMEI/CIDリスト
export const v2DeviceList = [
  "860728063217546",
  "860728065445160",
  "860728065446044",
  "860728065445129",
  "860728065048915",
  "860728065049079",
  "860728065041639",
  "860728065047818",
  "860728065048865",
  "860728065048444",
  "860728065444833",
  "860728065445764",
  "860728065445061",
  "860728065445418",
  "860728065446028",
  "860728065062908",
  "860728065445715",
  "860728065440559",
  "860728065046893",
  "860728065047834",
  "860728065054988",
  "860728065444650",
  "860728065444742",
  "860728065055365",
  "860728065445970",
  "860728065444858",
  "860728065060811",
  "860728065061215",
  "860728065444700",
  "860728065445921",
  "860728065440575",
  "860728065446077",
  "860728065445483",
  "860728065445525",
  "860728065048972",
  "860728065445095",
  "860728065444668",
  "860728065446010",
  "860728065057544",
  "860728065061199",
  "860728065445541",
  "860728065055100",
  "860728065444643",
  "860728065445830",
  "860728065444692",
  "860728065052172",
  "860728065444809",
  "860728065444635",
  "860728065445780",
  "860728065445756",
  "860728065445772",
  "860728065445939",
  "860728065444593",
  "860728065445426",
  "860728065069820",
  "860728065445335",
  "860728065053873",
  "860728065445681",
  "860728065445293",
  "860728065444882",
  "860728065445863",
  "860728065432234",
  "860728065043171",
  "860728065057809",
  "860728065059649",
  "860728065445871",
  "860728065445749",
  "860728065053030",
  "860728065444783",
  "860728065445913",
  "860728065068335",
  "860728065445467",
  "860728065444718",
  "860728065445822",
  "860728065445442",
  "860728065445533",
  "860728065063005",
  "860728065042694",
  "860728065445392",
  "860728065445376",
  "860728065444825",
  "860728065444619",
  "860728065445962",
  "860728065068368",
  "860728065444817",
  "860728065444759",
  "860728065445285",
  "860728065049111",
  "860728065047941",
  "860728065070547",
  "860728065445954",
  "860728065054574",
  "860728065444734",
  "860728065445004",
  "860728065440492",
  "860728065432176",
  "860728065432218",
  "860728065444601",
  "860728065444627",
  "860728065046943",
  "860728065445996",
  "860728065445491",
  "860728065049277",
  "860728065063302",
  "860728065041670",
  "860728065063500",
  "860728065432192",
  "860728065444676",
  "860728065445277",
  "860728065445889",
  "860728065042041",
  "860728065446085",
  "860728065444775",
  "860728065445806",
  "860728065061926",
  "860728065444841",
  "860728065445509",
  "860728065060142",
  "860728065064953",
  "860728065060993",
  "860728065445319",
  "860728065055852",
  "860728065445814",
  "860728065445905",
  "860728065445400",
  "860728065445640",
  "860728065446069",
  "860728065049558",
  "860728065444551",
  "860728065445731",
  "860728065445517",
  "860728065445111",
  "860728065062213",
  "860728065445947",
  "860728065445566",
  "860728065058187",
  "860728065445988",
  "860728065445848",
  "860728065068129",
  "860728065445798",
  "860728065445343",
  "860728065445855",
  "860728065444536",
  "860728065454204",
  "860728065445251",
  "860728065053808",
  "860728066669578",
  "860728066106803",
  "860728066646030",
  "860728066674347",
  "860728066652368",
  "860728066105177",
  "860728066452090",
  "860728066664926",
  "860728066663522",
  "860728066105227",
  "860728066108940",
  "860728066652673",
  "860728066665527",
  "860728066109559",
  "860728066647178",
  "860728066649877",
  "860728066645743",
  "860728066469789",
  "860728066669891",
  "860728066110193",
  "860728066651535",
  "860728066107306",
  "860728066451753",
  "860728066651006",
  "860728066678967",
  "860728066107199",
  "860728066652749",
  "860728066107173",
  "860728066652517",
  "860728066650032",
  "860728066678942",
  "860728066107918",
  "860728066448148",
  "860728066453627",
  "860728066452207",
  "860728066649901",
  "860728066106837",
  "860728066651394",
  "860728066649828",
  "860728066678926",
  "860728066108965",
  "860728065748746",
  "860728066476164",
  "860728066655767",
  "860728066651915",
  "860728066646147",
  "860728066646709",
  "860728066105169",
  "860728066106779",
  "860728066105870",
  "860728066651030",
  "860728066652848",
  "860728066108692",
  "860728066649794",
  "860728066651741",
  "860728066646311",
  "860728066652384",
  "860728066663464",
  "860728066108247",
  "860728066114583",
  "860728066647095",
  "860728066649729",
  "860728066106613",
  "860728066665576",
  "860728066106688",
  "860728066649786",
  "860728066108668",
  "860728066647475",
  "860728066107637",
  "860728066109922",
  "860728066669602",
  "860728065731742",
  "860728066452199",
  "860728066663290",
  "860728066669917",
  "860728066448304",
  "860728066448064",
  "860728066448270",
  "860728066650040",
  "860728066649935",
  "860728066451571",
  "860728066109351",
  "860728065716222",
  "860728065710852",
  "860728066473534",
  "860728066450508",
  "860728066107769",
  "860728066647459",
  "860728065715364",
  "860728066106076",
  "860728066107835",
  "860728066441390",
  "860728066464863",
  "860728066109047",
  "860728066460614",
  "860728066106886",
  "860728066109328",
  "860728066106753",
  "860728066107017",
  "860728066678934",
  "860728066114765",
  "860728066447934",
  "860728066669586",
  "860728066109211",
  "860728066114492",
  "860728066649869",
  "860728066643086",
  "860728066453569",
  "860728066655684",
  "860728066108429",
  "860728066105102",
  "860728066655833",
  "860728066105052",
  "860728066109476",
  "860728066107652",
  "860728066107900",
  "860728066650057",
  "860728066107710",
  "860728066650099",
  "860728066652871",
  "860728066108163",
  "860728066448254",
  "860728066646493",
  "860728066669321",
  "860728066669297",
  "860728066646378",
  "860728066645321",
  "860728066669362",
  "860728066479234",
  "860728066113049",
  "860728066102976",
  "860728066457016",
  "860728066108635",
  "860728066669420",
  "860728066669818",
  "860728066108551",
  "860728066452314",
  "860728066651600",
  "860728066109856",
  "860728066105524",
  "860728066480760",
  "860728066643946",
  "860728066646170",
  "860728066108312",
  "860728066448023",
  "860728066452074",
  "860728066448015",
  "860728066440749",
  "860728066479085",
  "860728066456638",
  "860728066647418",
  "860728065746765",
  "860728066647491",
  "860728066107678",
  "860728066114476",
  "860728066476859",
  "860728066110698",
  "860728066650008",
  "860728066651154",
  "860728066469714",
  "860728066459525",
  "860728066647236",
  "860728066450813",
  "860728065739380",
  "860728066649802",
  "860728066665378",
  "860728066107686",
  "860728066669537",
  "860728066652731",
  "860728066451795",
  "860728066107124",
  "860728066652426",
  "860728066646451",
  "860728066109146",
  "860728066647624",
  "860728066448221",
  "860728066109427",
  "860728066113148",
  "860728066652640",
  "860728066106951",
  "860728066110375",
  "860728066459368",
  "860728066106738",
  "860728065714805",
  "860728066449849",
  "860728066647202",
  "860728066669974",
  "860728066448411",
  "860728066669735",
  "860728066107298",
  "860728066665618",
  "860728066651550",
  "860728066649976",
  "860728066449906",
  "860728066459327",
  "860728066448080",
  "860728066650115",
  "860728066651832",
  "860728066649950",
  "860728066109781",
  "860728066452132",
  "860728066650149",
  "860728066448114",
  "860728066107751",
  "860728066669883",
  "860728066652087",
  "860728066655577",
  "860728066108767",
  "860728066107876",
  "860728066646758",
  "860728066449732",
  "860728066451498",
  "860728066106381",
  "860728066652475",
  "860728066107777",
  "860728066652509",
  "860728066449351",
  "860728066663514",
  "860728066663480",
  "860728066669339",
  "860728066649943",
  "860728066669644",
  "860728066652681",
  "860728066123923",
  "860728066448387",
  "860728066105110",
  "860728066646279",
  "860728066478343",
  "860728066649893",
  "860728066107660",
  "860728066460176",
  "860728066460192",
  "860728066108205",
  "860728066107470",
  "860728066431086",
  "860728066107462",
  "860728066110359",
  "860728066651618",
  "860728066107579",
  "860728066448353",
  "860728066107140",
  "860728066669628",
  "860728066646360",
  "860728066459459",
  "860728066106639",
  "860728066105235",
  "860728066663381",
  "860728066452256",
  "860728066105151",
  "860728065747284",
  "860728066106787",
  "860728066646766",
  "860728066106977",
  "860728066647061",
  "860728066647582",
  "860728066652541",
  "860728066108734",
  "860728066665535",
  "860728066108361",
  "860728066649588",
  "860728066111191",
  "860728066459350",
  "860728066670170",
  "860728066461083",
  "860728066646840",
  "860728066452645",
  "860728066113122",
  "860728066469672",
  "860728066647087",
  "860728066652715",
  "860728066652285",
  "860728066646261",
  "860728066448189",
  "860728066451902",
  "860728066652897",
  "860728066651675",
  "860728066478335",
  "860728065735461",
  "860728066106852",
  "860728066646501",
  "860728066448601",
  "860728066104931",
  "860728066459202",
  "860728066108619",
  "860728066106795",
  "860728065742434",
  "860728066448320",
  "860728066452322",
  "860728066105862",
  "860728066652632",
  "860728066643045",
  "860728066652228",
  "860728066112538",
  "860728066109757",
  "860728066646667",
  "860728066106340",
  "860728066665428",
  "860728066651865",
  "860728066454625",
  "860728066647467",
  "860728065728292",
  "860728066469854",
  "860728066647517",
  "860728065706629",
  "860728066103313",
  "860728066646238",
  "860728066652103",
  "860728066646550",
  "860728066474862",
  "860728066109187",
  "860728066106589",
  "860728066647731",
  "860728066652277",
  "860728066109997",
  "860728066643631",
  "860728066652491",
  "860728066651634",
  "860728066107132",
  "860728066655536",
  "860728066123279",
  "860728066454476",
  "860728066652376",
  "860728066449161",
  "860728066655437",
  "860728065706017",
  "860728065714268",
  "860728066454658",
  "860728066107496",
  "860728066449260",
  "860728066655759",
  "860728066448841",
  "860728066652152",
  "860728066448205",
  "860728066109690",
  "860728066106670",
  "860728066448296",
  "860728066655841",
  "860728066109237",
  "860728066655817",
  "860728066650024",
  "860728066646097",
  "860728066663415",
  "860728066655544",
  "860728066669834",
  "860728066106092",
  "860728066649737",
  "860728066646576",
  "860728066108072",
  "860728066649992",
  "860728066669719",
  "860728066652525",
  "860728066106712",
  "860728066459384",
  "860728066644597",
  "860728066669859",
  "860728066459392",
  "860728066109823",
  "860728066649778",
  "860728066106407",
  "860728066463303",
  "860728066448346",
  "860728066655676",
  "860728066110383",
  "860728066650875",
  "860728066478608",
  "860728066107819",
  "860728066106423",
  "860728066649745",
  "860728066449013",
  "860728066665485",
  "860728066669388",
  "860728066646832",
  "860728066471488",
  "860728066646402",
  "860728066106704",
  "860728066655874",
  "860728066106548",
  "860728066679007",
  "860728066448429",
  "860728066108387",
  "860728066646196",
  "860728066106662",
  "860728066651576",
  "860728066665568",
  "860728066475141",
  "860728066652707",
  "860728066448197",
  "860728066452355",
  "860728066647442",
  "860728066655742",
  "860728066655825",
  "860728066105243",
  "860728066452587",
  "860728066106050",
  "860728066655619",
  "860728066107553",
  "860728066448890",
  "860728066669677",
  "860728066107116",
  "860728066448338",
  "860728066655858",
  "860728066448718",
  "860728066106084",
  "860728066452025",
  "860728066643557",
  "860728066651709",
  "860728066647046",
  "860728066108676",
  "860728065750080",
  "860728066110003",
  "860728066108114",
  "860728066463840",
  "860728066665600",
  "860728066647053",
  "860728066448056",
  "860728066105086",
  "860728066107892",
  "860728065747870",
  "860728066105979",
  "860728066115549",
  "860728066652442",
  "860728066110276",
  "860728066652210",
  "860728065713369",
  "860728066447975",
  "860728066124046",
  "860728066109310",
  "860728066647079",
  "860728065718301",
  "860728066470944",
  "860728066106696",
  "860728066646998",
  "860728066106167",
  "860728066450912",
  "860728066459400",
  "860728066647194",
  "860728066646634",
  "860728066647293",
  "860728066108577",
  "860728066478285",
  "860728066459178",
  "860728066107033",
  "860728065707270",
  "860728066665543",
  "860728066108080",
  "860728066652665",
  "860728066452454",
  "860728066647343",
  "860728066108098",
  "860728066665444",
  "860728066108197",
  "860728066448239",
  "860728066472338",
  "860728066643797",
  "860728066665493",
  "860728066645412",
  "860728066454054",
  "860728066105094",
  "860728066454575",
  "860728066120226",
  "860728066646600",
  "860728066449245",
  "860728066110300",
  "860728066651691",
  "860728066650883",
  "860728065749553",
  "860728066105029",
  "860728066663399",
  "860728066442349",
  "860728066647384",
  "860728066646899",
  "860728066102919",
  "860728066106993",
  "860728066647327",
  "860728066466850",
  "860728066643839",
  "860728066462982",
  "860728066669768",
  "860728066109765",
  "860728065745312",
  "860728066655692",
  "860728066457156",
  "860728066110904",
  "860728066457487",
  "860728066646683",
  "860728066107538",
  "860728066448247",
  "860728066646253",
  "860728066649604",
  "860728066674404",
  "860728066450045",
  "860728066652301",
  "860728066104980",
  "860728066123006",
  "860728066107272",
  "860728066643532",
  "860728066106159",
  "860728066669487",
  "860728066105300",
  "860728066452306",
  "860728066105813",
  "860728066664884",
  "860728066479465",
  "860728066643565",
  "860728066651790",
  "860728066434718",
  "860728066647756",
  "860728066679015",
  "860728066126595",
  "860728066108700",
  "860728066105946",
  "860728066646659",
  "860728066107736",
  "860728066665519",
  "860728066440392",
  "860728066106118",
  "860728066467395",
  "860728066124269",
  "860728066439741",
  "860728066663456",
  "860728066109260",
  "860728066109377",
  "860728066439089",
  "860728066655601",
  "860728066108684",
  "860728066453775",
  "860728066107595",
  "860728066479176",
  "860728066655726",
  "860728066478517",
  "860728066451621",
  "860728066108189",
  "860728066107512",
  "860728065716099",
  "860728066123444",
  "860728066453197",
  "860728066103297",
  "860728066447983",
  "860728066648572",
  "860728066105326",
  "860728066459210",
  "860728066106860",
  "860728066459509",
  "860728066646964",
  "860728066669966",
  "860728066107041",
  "860728066651758",
  "860728066109054",
  "860728066646931",
  "860728066108593",
  "860728066646246",
  "860728066109492",
  "860728066108403",
  "860728065732781",
  "860728066109831",
  "860728066643573",
  "860728066469938",
  "860728066110342",
  "860728066120382",
  "860728066451803",
  "860728066670204",
  "860728066107157",
  "860728066448700",
  "860728066106357",
  "860728066651725",
  "860728066452371",
  "860728066109534",
  "860728066115630",
  "860728066109518",
  "860728066663365",
  "860728066669685",
  "860728066646352",
  "860728066115317",
  "860728066107744",
  "860728066663449",
  "860728066459590",
  "860728066106845",
  "860728066452215",
  "860728066108239",
  "860728066646790",
  "860728066452231",
  "860728066109419",
  "860728066459418",
  "860728066646915",
  "860728066105920",
  "860728066655718",
  "860728066474748",
  "860728066109013",
  "860728066453346",
  "860728066669826",
  "860728066107066",
  "860728066449203",
  "860728066109021",
  "860728065744968",
  "860728066107181",
  "860728066123121",
  "860728066670006",
  "860728066107009",
  "860728066108478",
  "860728066653358",
  "860728066459475",
  "860728066646741",
  "860728066104972",
  "860728066453320",
  "860728066478988",
  "860728066649810",
  "860728066479432",
  "860728066646584",
  "860728066643920",
  "860728066669479",
  "860728066646287",
  "860728066433090",
  "860728066109864",
  "860728066468351",
  "860728066647137",
  "860728066106282",
  "860728066105839",
  "860728066649091",
  "860728066451480",
  "860728066106373",
  "860728066113007",
  "860728066459574",
  "860728066105367",
  "860728066644746",
  "860728066106258",
  "860728066647301",
  "860728066112272",
  "860728066106324",
  "860728066449039",
  "860728066109963",
  "860728066655866",
  "860728066448460",
  "860728066652814",
  "860728066647277",
  "860728066106761",
  "860728066107058",
  "860728066652350",
  "860728066107488",
  "860728066107587",
  "860728066647392",
  "860728066454443",
  "860728066647400",
  "860728066647319",
  "860728066454583",
  "860728066669958",
  "860728066477071",
  "860728066109344",
  "860728066452249",
  "860728066669800",
  "860728066449195",
  "860728066453577",
  "860728066480000",
  "860728066452447",
  "860728066643078",
  "860728066449401",
  "860728066459699",
  "860728066652202",
  "860728066646956",
  "860728066123212",
  "860728066649919",
  "860728066451738",
  "860728066106985",
  "860728066651972",
  "860728066449658",
  "860728066105953",
  "860728066652939",
  "860728066108460",
  "860728066655627",
  "860728066655510",
  "860728066646774",
  "860728066669933",
  "860728066110250",
  "860728066120291",
  "860728066474763",
  "860728066449724",
  "860728066651998",
  "860728066643029",
  "860728066472882",
  "860728066645982",
  "860728066647160",
  "860728066647657",
  "860728065706165",
  "860728066109583",
  "860728066452173",
  "860728066459251",
  "860728066652699",
  "860728066448155",
  "860728066452611",
  "860728066109948",
  "860728066459269",
  "860728065715844",
  "860728066479499",
  "860728066431300",
  "860728066649703",
  "860728066109062",
  "860728066463642",
  "860728066124020",
  "860728066107785",
  "860728066109435",
  "860728066112850",
  "860728066111852",
  "860728066479069",
  "860728066448361",
  "860728066648234",
  "860728066468476",
  "860728066115309",
  "860728066448262",
  "860728066121430",
  "860728066439071",
  "860728066674453",
  "860728066453858",
  "860728066453619",
  "860728066454781",
  "860728066106571",
  "860728066665436",
  "860728066472080",
  "860728066652863",
  "860728066647285",
  "860728066467262",
  "860728066448817",
  "860728066448734",
  "860728066459616",
  "860728066105003",
  "860728066651584",
  "860728066107322",
  "860728066459491",
  "860728066110185",
  "860728066110037",
  "860728065731783",
  "860728065722832",
  "860728066110227",
  "860728066647863",
  "860728066107389",
  "860728066646394",
  "860728066451910",
  "860728066106506",
  "860728066109385",
  "860728066452579",
  "860728066107843",
  "860728066448973",
  "860728066471264",
  "860728066110284",
  "860728066110318",
  "860728065728227",
  "860728066646816",
  "860728066110169",
  "860728066109633",
  "860728066105276",
  "860728066440277",
  "860728066108171",
  "860728066454930",
  "860728066459624",
  "860728066646303",
  "860728066670048",
  "860728066108304",
  "860728066108544",
  "860728066646048",
  "860728066110268",
  "860728066106001",
  "860728066105854",
  "860728066451142",
  "860728066115572",
  "860728066107413",
  "860728066110078",
  "860728066107355",
  "860728066105409",
  "860728066105375",
  "860728066450706",
  "860728066480299",
  "860728066109138",
  "860728066473914",
  "860728066451555",
  "860728066669990",
  "860728066109302",
  "860728065731684",
  "860728066108981",
  "860728066669669",
  "860728066643888",
  "860728066452264",
  "860728066646063",
  "860728066651642",
  "860728066105938",
  "860728066451928",
  "860728066643854",
  "860728066103289",
  "860728066643599",
  "860728066105334",
  "860728066647707",
  "860728066452181",
  "860728066449021",
  "860728066663498",
  "860728066448783",
  "860728066109989",
  "860728066451944",
  "860728066110326",
  "860728066652335",
  "860728066449765",
  "860728066107793",
  "860728065706959",
  "860728066109625",
  "860728066107215",
  "860728066669552",
  "860728066106217",
  "860728066109252",
  "860728066452223",
  "860728066647681",
  "860728065740420",
  "860728066655650",
  "860728066109294",
  "860728066108338",
  "860728066434742",
  "860728066108296",
  "860728066106308",
  "860728066106019",
  "860728066646329",
  "860728066646220",
  "860728066652178",
  "860728066109906",
  "860728066107405",
  "860728066120903",
  "860728066448312",
  "860728066105045",
  "860728066106811",
  "860728066108494",
  "860728066655965",
  "860728066107231",
  "860728066652434",
  "860728066105391",
  "860728066665394",
  "860728066111506",
  "860728066459533",
  "860728066109732",
  "860728066647210",
  "860728066646642",
  "860728066110094",
  "860728066110292",
  "860728066106944",
  "860728066478566",
  "860728066647723",
  "860728066110144",
  "860728066652244",
  "860728066649851",
  "860728066107363",
  "860728066460036",
  "860728065712668",
  "860728066109567",
  "860728066646055",
  "860728066646139",
  "860728066645909",
  "860728066448874",
  "860728066665402",
  "860728066107504",
  "860728065737939",
  "860728066115754",
  "860728066107348",
];

// デバイスがV2かどうかを判定する関数
export function isV2Device(cid) {
  return v2DeviceList.includes(cid);
}
